import { useCart } from '@shopify/hydrogen-react';
import React, { useState } from 'react';
import { NotificationMessages } from '../../common/notificationMessages';
import Button, { ButtonSize, ButtonVariation } from '../../components/ui/Button';
import FlashMessages from '../../components/ui/FlashMessages';
import { useStoreState } from '../../store';
import { resolveCollectionBackPath } from '../../utils/collectionBackNavigation';
import { topNavigate } from '../../utils/iframe/topNavigate';
import { getMultipassCheckoutUrl } from '../../utils/multipass/getMultipassCheckoutUrl';

interface Props {
  disableCheckout?: boolean;
}

const CartBottom: React.FC<Props> = ({ disableCheckout = false }) => {
  const { checkoutUrl } = useCart();
  const orgId = useStoreState(state => state.orgContext.orgId);
  const collectionHandle = useStoreState(state => state.orgContext.collectionHandle);
  const backPath = resolveCollectionBackPath({ orgId, collectionHandle });
  const [checkoutInFlight, setCheckoutInFlight] = useState(false);

  const checkoutAction = async () => {
    if (!checkoutUrl || checkoutInFlight) return;
    setCheckoutInFlight(true);
    try {
      const destination = await getMultipassCheckoutUrl(checkoutUrl);
      topNavigate(destination);
    } catch {
      FlashMessages.error(NotificationMessages.DEFAULT_ERROR);
      setCheckoutInFlight(false);
    }
  };

  return (
    <div className="cart-actions">
      <Button
        className="cart-action"
        disabled={disableCheckout || checkoutInFlight}
        onClick={() => checkoutAction()}
        variation={ButtonVariation.PRIMARY}
        size={ButtonSize.LARGE}
      >
        {checkoutInFlight ? 'Redirecting…' : 'Checkout Securely'}
      </Button>

      {backPath && (
        <Button href={backPath} type="link" variation={ButtonVariation.PRIMARY_OUTLINED}>
          Continue Shopping
        </Button>
      )}
    </div>
  );
};

export default CartBottom;
